import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { checkConsentAndInitializeAnalyticsIfAllowed } from '../../../../common/config'
import { getLanguageCode } from '../../../../common/utils/translation-helper'
import { getTranslation, fetch } from '../common/operations'
import { ActivationPage } from './activation-page/activation-page'

const propTypes = {
    addTranslations: PropTypes.func,
    fetchTranslateSuccess: PropTypes.boolean,
    setFetchTranslateSuccess: PropTypes.func,
    translations: PropTypes.array // eslint-disable-line react/forbid-prop-types
}

const Main = ({ addTranslations, fetchTranslateSuccess, setFetchTranslateSuccess, translations }) => {
    const [currentLocale, setCurrentLocale] = useState('en_GB')

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search)

        const languageData = getLanguageCode(urlParams.get('locale'))
        const locale = languageData.locale.replace('-', '_')

        setCurrentLocale(locale)

        const translationsOptions = Object.assign(
            {},
            {
                method: 'GET',
                url: `/api/translations?contextCode=ACTIVATIONPAGE&locale=${locale}`
            }
        )

        fetch(translationsOptions)
            .then(res => {
                addTranslations(res.data)
                setFetchTranslateSuccess(true)
            })
            .catch(err => console.error(err))

        checkConsentAndInitializeAnalyticsIfAllowed()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getIntlObject = () => {
        const intl = {
            langCode: () => {
                return currentLocale.toLowerCase()
            },
            styledTranslate: (
                stringCode,
                textStylingClass,
                stylingTags = {
                    CLOSING: '</s>',
                    OPENING: '<s>'
                }
            ) => {
                const translatedString = intl.translate(stringCode)
                const indexOfStylingTagEnter = translatedString.indexOf(stylingTags.OPENING)
                const indexOfStylingTagClosing = translatedString.indexOf(stylingTags.CLOSING)

                const stringBefore = translatedString.substring(0, indexOfStylingTagEnter)
                const styledString = translatedString.substring(
                    indexOfStylingTagEnter + stylingTags.OPENING.length,
                    indexOfStylingTagClosing
                )
                const stringAfter = translatedString.substring(indexOfStylingTagClosing + stylingTags.CLOSING.length)

                return (
                    <div>
                        {stringBefore}
                        <span className={textStylingClass}>{styledString}</span>
                        {stringAfter}
                    </div>
                )
            },
            translate: (stringCode, ...args) => {
                let translation = getTranslation(translations, stringCode)
                // eslint-disable-next-line no-unused-vars
                for (const a of args) {
                    translation = translation.replace(/({\$\w+})/, a)
                }
                return translation.replace(/<br>/g, '\n')
            },
            translateWithLink: (
                stringCode,
                address,
                linkTags = {
                    CLOSING: '</link>',
                    OPENING: '<link>'
                }
            ) => {
                const translatedString = intl.translate(stringCode)
                const indexOfStylingTagEnter = translatedString.indexOf(linkTags.OPENING)
                const indexOfStylingTagClosing = translatedString.indexOf(linkTags.CLOSING)

                const stringBefore = translatedString.substring(0, indexOfStylingTagEnter)
                const linkedString = translatedString.substring(
                    indexOfStylingTagEnter + linkTags.OPENING.length,
                    indexOfStylingTagClosing
                )
                const stringAfter = translatedString.substring(indexOfStylingTagClosing + linkTags.CLOSING.length)

                return (
                    <div>
                        {stringBefore}
                        <a href={address} target="_blank">
                            {linkedString}
                        </a>
                        {stringAfter}
                    </div>
                )
            }
        }
        return intl
    }

    const intl = getIntlObject()

    return <ActivationPage {...{ fetchTranslateSuccess, intl }} />
}

Main.propTypes = propTypes

export { Main }
